var React = require('react');

function SewingmachineInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 .489a4.5 4.5 0 0 0-4.5 4.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v9.5a1 1 0 0 1-1 1h-13a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h20a1 1 0 0 0 1-1v-20.5a1.5 1.5 0 0 0-1.5-1.5zM5.499 10.489v5.5M5.499 14.489h1","key":0}),React.createElement("circle",{"className":"cls-1","cx":"19.999","cy":"17.989","r":"1.5","key":1}),React.createElement("path",{"className":"cls-1","d":"M12.999 3.489h10.5M.499 20.489h15","key":2})]);
}

SewingmachineInline.defaultProps = {"className":"stroke","viewBox":"0 0 24 24"};

module.exports = SewingmachineInline;

SewingmachineInline.default = SewingmachineInline;
